export default function Footnote({children}) {

    return (
        <div style={{fontSize: '9pt'}}>
            {children}
        </div>
    )
}